var React = require('react');

function RssIconBlue (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.574,45.712a2.287,2.287,0,1,1-2.287-2.287A2.287,2.287,0,0,1,4.574,45.712ZM10.848,47.4A10.86,10.86,0,0,0,.6,37.152a.571.571,0,0,0-.6.571V39.44a.572.572,0,0,0,.532.572,8,8,0,0,1,7.456,7.456A.572.572,0,0,0,8.56,48h1.717a.571.571,0,0,0,.571-.6ZM16,47.41A16.011,16.011,0,0,0,.589,32,.571.571,0,0,0,0,32.572v1.717a.573.573,0,0,0,.552.571A13.145,13.145,0,0,1,13.14,47.448a.573.573,0,0,0,.571.552h1.717A.571.571,0,0,0,16,47.41Z","transform":"translate(0 -32)","fill":"#4db2ec"}));
}

RssIconBlue.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = RssIconBlue;

RssIconBlue.default = RssIconBlue;
